var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 95.0019H15V52.5019C15.2547 50.7301 15.4469 48.9457 15.7766 47.1879C18.7625 31.2488 32.0531 18.2457 48.0297 15.6176C49.5125 15.3738 51.0094 15.2051 52.5 15.002H57.5C57.7 15.0457 57.9 15.0988 58.1016 15.1316C60.1547 15.4504 62.2375 15.6395 64.2578 16.102C79.6641 19.6238 91.7875 32.5223 94.3938 48.1066C94.6375 49.5645 94.8 51.0363 95 52.5019V95.0019H89.2188C89.1953 94.9566 89.1813 94.9019 89.1484 94.866C81.9594 87.2629 74.7719 79.6598 67.5656 72.0738C67.3688 71.866 66.9875 71.7394 66.6906 71.7363C64.2188 71.7098 61.7453 71.7207 59.2719 71.7207H58.1172V79.4769H51.8594V71.7207H51.0453C48.5203 71.7207 45.9953 71.7332 43.4703 71.7098C42.9625 71.7051 42.6109 71.8519 42.2578 72.2269C37.7984 76.966 33.3172 81.6832 28.85 86.4144C26.1531 89.2707 23.4719 92.1394 20.7828 95.0019H20.7812ZM88.7234 85.3144C88.7375 84.9941 88.7484 84.866 88.7484 84.7379C88.7484 74.7394 88.7531 64.741 88.7422 54.7441C88.7391 51.7098 88.3 48.7301 87.4719 45.8098C82.2969 27.5801 63.0687 17.1488 45.0062 22.7691C30.8766 27.1676 21.3031 40.1582 21.2563 55.0644C21.225 64.8801 21.25 74.6957 21.2516 84.5113C21.2516 84.7285 21.2781 84.9441 21.2969 85.2191C21.4313 85.1207 21.4984 85.0848 21.55 85.0316C27.0109 79.266 32.4734 73.5035 37.9141 67.7191C38.1437 67.4738 38.2641 67.0316 38.2656 66.6801C38.2906 62.9566 38.2719 59.2332 38.2875 55.5098C38.2906 54.6535 38.3359 53.7926 38.4266 52.9394C39.4141 43.6191 48.6469 36.7879 57.8719 38.5395C66.0844 40.0988 71.6984 46.8488 71.7172 55.1973C71.725 58.9988 71.7281 62.8004 71.7078 66.6019C71.7047 67.1379 71.8594 67.5191 72.2281 67.9066C75.7141 71.5613 79.1797 75.2363 82.6531 78.9035C84.6359 80.9973 86.6188 83.091 88.7234 85.3129V85.3144ZM65.4437 65.4363C65.4531 65.2269 65.4672 65.0738 65.4672 64.9223C65.4672 61.5644 65.4797 58.2066 65.4563 54.8488C65.4516 54.1769 65.3766 53.4941 65.2328 52.8379C64.0875 47.6082 59.2313 44.0301 54.0438 44.5676C48.5906 45.1332 44.5547 49.5691 44.5328 55.041C44.5187 58.2941 44.5297 61.5488 44.5297 64.8019V65.4363H65.4437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.875 95.002V85.5254H58.125V95.002H51.875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80.0016,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunnel);
export default __webpack_public_path__ + "static/media/tunnel.6a0f091fdfe7060f4b8c34e68314e13b.svg";
export { ForwardRef as ReactComponent };